import AppModule from "../../services/App/AppModule.js";
import ModelBody from "./PlosModel_Body.js";

// formula: CashBased
export default {
  getSummary(transactionDetails) {
    let result = ModelBody.createSummary();
    let newTransRow;

    newTransRow = this.getSummary_createTransRow(
      AppModule.HppAdj.FullName, transactionDetails.HppAdjTotal, null
    );
    result.TransactionList.push(newTransRow);

    newTransRow = this.getSummary_createTransRow(
      AppModule.Pos.FullName, transactionDetails.PosTotal, null
    );
    result.TransactionList.push(newTransRow);

    newTransRow = this.getSummary_createTransRow(
      AppModule.DebtPay.FullName, transactionDetails.DebtPay.VoidTotal,
      transactionDetails.DebtPay.AllTotal
    );
    result.TransactionList.push(newTransRow);

    newTransRow = this.getSummary_createTransRow(
      AppModule.RecPay.FullName, transactionDetails.RecPay.AllTotal,
      transactionDetails.RecPay.VoidTotal
    );
    result.TransactionList.push(newTransRow);

    newTransRow = this.getSummary_createTransRow(
      AppModule.Expense.FullName, null, transactionDetails.ExpenseTotal
    );
    result.TransactionList.push(newTransRow);

    newTransRow = this.getSummary_createTransRow(
      AppModule.StockOpname.FullName, transactionDetails.StockOpnameTotal, null
    );
    result.TransactionList.push(newTransRow);

    newTransRow = this.getSummary_createTransRow(
      AppModule.StockReduction.FullName, null,
      transactionDetails.StockReductionTotal
    );
    result.TransactionList.push(newTransRow);

    if (Object.prototype.hasOwnProperty.call(transactionDetails, "StockTrf")) {
      newTransRow = this.getSummary_createTransRow(
        AppModule.StockTrf.FullName, transactionDetails.StockTrf.AddTotal,
        transactionDetails.StockTrf.SubTotal
      );
      result.TransactionList.push(newTransRow);
    }

    for (const row of result.TransactionList) {
      if (row.AddTotal !== null) {
        result.Total += row.AddTotal;
      }

      if (row.SubTotal !== null) {
        result.Total -= row.SubTotal;
      }
    }

    return result;
  },
  getSummary_createTransRow(moduleName, addTotal, subTotal) {
    return {
      Label: moduleName,
      AddTotal: addTotal,
      SubTotal: subTotal
    };
  }
}